$(function () {
    // MENU
    const navigation = $('nav');
    const centerNav = $('#center-nav');
    const rightNav = $('#right-nav');
    const dropdownMoreButton = $('#dropdownMoreButton');
    const dropdownMoreContent = $('#dropdownMoreButtonContent');

    const updateMenu = function () {
        var isDropdownEmpty = true;
        dropdownMoreContent.empty();
        navigation.children().each(function (i, child) {
            const offsetTop = navigation.offset().top;
            const shouldBeInMoreDropdown = $(child).offset().top > offsetTop;
            if (shouldBeInMoreDropdown) {
                isDropdownEmpty = false;
                const newAnchorElem = $(child).clone();
                newAnchorElem.removeClass('btn')
                    .removeClass('link')
                    .addClass('dropdown-item')
                    .addClass('cursor-pointer');
                dropdownMoreContent.append(newAnchorElem);
            }
        });
        if (isDropdownEmpty) {
            dropdownMoreButton.css({
                display: 'none'
            });
        } else {
            dropdownMoreButton.css({
                display: 'block'
            });
        }
    }

    dropdownMoreButton.show();
    centerNav.css({
        'margin-right': rightNav.width() + 24 + 'px'
    });
    dropdownMoreButton.click(updateMenu);
    $(window).resize(updateMenu);
    updateMenu();

    // COUNTDOWN
    const setUpCountDown = function () {
        const eventDetailSection = $("#event-detail-section");
        const countdownSection = $("#countdown-section");
        const countdown = $("#start-countdown");
        const countdownElements = countdown.find('h1');

        const timezoneOffset = new Date().getTimezoneOffset();
        // safari is the best web page viewer ever https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        const eventStartDateTime = new Date(data.eventStartDateTimeInUTC.replace(/-/g, "/"));
        const eventStartDateTimeInUserTimezone = new Date(eventStartDateTime.getTime() - timezoneOffset * 60000);

        countdown.countdown(eventStartDateTimeInUserTimezone, function (event) {
            if (event.type === 'update') {
                eventDetailSection.hide();
                countdownSection.show();
            }
            if (event.type === 'finish') {
                eventDetailSection.show();
                countdownSection.hide();
            }
            countdownElements.each(function (index, elem) {
                let durationPart = 0;
                let shouldPad = false;
                switch (index) {
                    case 0:
                        durationPart = event.offset.totalDays;
                        shouldPad = false;
                        break;
                    case 1:
                        durationPart = event.offset.hours;
                        shouldPad = event.offset.totalDays > 0;
                        break;
                    case 2:
                        durationPart = event.offset.minutes;
                        shouldPad = event.offset.totalHours > 0;
                        break;
                    case 3:
                        durationPart = event.offset.seconds;
                        shouldPad = event.offset.totalMinutes > 0;
                        break;
                }
                let retVal = durationPart.toString();
                if (shouldPad) {
                    retVal = retVal.padStart(2, '0');
                }
                $(elem).text(retVal);
            })
        });
    }

    if (!!data.eventStartDateTimeInUTC) {
        setUpCountDown();
    }
});
